/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Tree from 'src/common/components/Tree';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import {
	formatOrders,
	getIssue,
	secciones,
	seccionesAsamblea,
	seccionesAux,
	seccionesOrdAudi,
	seccionesOrdCA,
	seccionesOrdVigilancia,
} from './utils/list_data';
import { orderOfTheDayAPI } from 'src/api/modules/orderOfTheDay';
import notice from 'src/common/components/Notice';
import AddNewOrder from './modals/AddNewOrder';
import AddFiles from './modals/AddFiles';
import DeleteOrder from './modals/DeleteOrder';
import DetailOrder from './modals/DetailOrder';
import ViewOrder from './modals/ViewOrder';

const OrderOfTheDay = ({ session, user, organoId, canEdit, dataSesAux, valOrgan }) => {
	const [isFetchOrders, SetIsFetchOrders] = useState(false);
	const [addFilesModal, setAddFilesModal] = useState(false);
	const [updateText, setUpdateText] = useState(false);
	const [datos, setTree] = useState([]);
	const [forApproval, setForApproval] = useState([]);
	const [forKnowledge, setForKnowledge] = useState([]);
	const [generalBusiness, setGeneralBusiness] = useState([]);
	const [addMatters, setAddMatters] = useState([]);
	const [opinions, setOpinions] = useState([]);

	const openAddFilesModal = (item) => {
		setItemSelectedFile(item);
		setAddFilesModal(true);
	};

	function moveItem(id, afterId, nodeId) {
		if (id === afterId) return;
		let cloneTree = [...datos];
		const removeNode = (id, items) => {
			for (const node of items) {
				if (node.id === id) {
					items.splice(items.indexOf(node), 1);
					return;
				}
				if (node.subItems && node.subItems.length) {
					removeNode(id, node.subItems);
				}
			}
		};

		const item = { ...findItem(id, cloneTree) };
		if (!item.id) {
			return;
		}
		const destination = nodeId ? findItem(nodeId, cloneTree).subItems : cloneTree;
		if (!afterId) {
			removeNode(id, cloneTree);
			destination.push(item);
		} else {
			const index = destination.indexOf(
				destination
					.filter((destinationItem) => destinationItem.id === afterId)
					.shift()
			);
			removeNode(id, cloneTree);
			destination.splice(index, 0, item);
		}
		setTree(cloneTree);
	}

	function findItem(id, items) {
		if (!items) return;
		for (const node of items) {
			if (node.id === id) return node;
			if (node.subItems && node.subItems.length) {
				const result = findItem(id, node.subItems);
				if (result) {
					return result;
				}
			}
		}
		return false;
	}

	function filterResponse(array) {
		const lstApproval = [],
			lstKnowledge = [],
			lstGeneralBusiness = [],
			lstAddMatters = [],
			lstOpinions = [];

		array.forEach((el) => {
			if (el.asunto === 'PA') lstApproval.push(el);
			else if (el.asunto === 'PC') lstKnowledge.push(el);
			else if (el.asunto === 'AC') lstGeneralBusiness.push(el);
			else if (el.asunto === 'AD') lstAddMatters.push(el);
			else if (el.asunto === 'DO') lstOpinions.push(el);
		});

		return [
			lstApproval,
			lstKnowledge,
			lstGeneralBusiness,
			lstAddMatters,
			lstOpinions,
		];
	}

	// Get order of the day
	const fetchOrderOfTheDay = async (session) => {
		orderOfTheDayAPI
			.getOrderOfTheDay(session)
			.then((response) => {
				SetIsFetchOrders(true);

				const [
					listForApproval,
					listForKnowledge,
					listGeneralBusiness,
					listForAddMatters,
					lstOpinions,
				] = filterResponse(response);
				setForApproval(formatOrders(listForApproval));
				setForKnowledge(formatOrders(listForKnowledge));
				setGeneralBusiness(formatOrders(listGeneralBusiness));
				setAddMatters(formatOrders(listForAddMatters));
				setOpinions(formatOrders(lstOpinions));
			})
			.catch((e) => {
				SetIsFetchOrders(false);
				notice(
					'Algo ha salido mal al cargar las ordenes del día, intente de nuevo'
				);
			});
	};

	const fetchData = async () => {
		await fetchOrderOfTheDay(session);
	};

	useEffect(() => {
		fetchData();
	}, []);

	const [isNewOrderModal, setIsNewOrderModal] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const openModalAddNewOrder = (e) => {
		setModalTitle(e);
		setIsNewOrderModal(true);
	};

	const [isViewOrderModal, setIsViewOrderModal] = useState(false);
	const viewOrder = (item) => {
		setItemSelected(item);
		setIsViewOrderModal(true);
	};

	const [isDeleteOrderModal, setIsDeleteOrderModal] = useState(false);
	const [itemSelected, setItemSelected] = useState(0);
	const [itemSelectedFile, setItemSelectedFile] = useState(0);
	const deleteOrder = (item, issue) => {
		setItemSelected(item);
		setModalTitle(issue);
		setIsDeleteOrderModal(true);
	};

	const [isDetailOrderModal, setIsDetailOrderModal] = useState(false);
	const detailOrder = (item, issue, updateInput, input) => {
		issue = getIssue(item.asunto);
		setItemSelected({ ...item, input });
		setModalTitle(issue || '');
		setIsDetailOrderModal(true);
		if (updateInput) setUpdateText(true);
	};

	return (
		<div>
			{isFetchOrders && (
				<>
					<div className="card">
						<DndProvider backend={HTML5Backend}>
							<Tree
								mainAction={(e) => openModalAddNewOrder(e)}
								parent={null}
								hasGrouping={{
									status: true,
									groups:
										dataSesAux.nameOrgan === 'Comité de Auditoría'
											? seccionesOrdAudi(
													forApproval,
													forKnowledge,
													addMatters,
													opinions
												)
											: dataSesAux.nameOrgan ===
												  'Comisión de Vigilancia'
												? seccionesOrdVigilancia(
														forApproval,
														forKnowledge,
														opinions
													)
												: dataSesAux.nameOrgan ===
															'Asamblea General' &&
													  dataSesAux.fhora <
															new Date('2025-03-19')
													? seccionesAsamblea(generalBusiness)
													: valOrgan === 'G2' &&
														  dataSesAux.fhora >
																new Date('2025-03-19')
														? seccionesOrdCA(
																forApproval,
																forKnowledge,
																generalBusiness,
																addMatters
															)
														: dataSesAux.organoColegiado
																	.esAuxiliar === true
															? seccionesAux(
																	forApproval,
																	forKnowledge,
																	generalBusiness
																)
															: valOrgan === 'G1'
																? seccionesOrdCA(
																		forApproval,
																		forKnowledge,
																		generalBusiness,
																		addMatters
																	)
																: secciones(
																		forApproval,
																		forKnowledge,
																		generalBusiness
																	),
								}}
								move={moveItem}
								find={findItem}
								onItemDetail={viewOrder}
								onItemView={detailOrder}
								onItemFiles={openAddFilesModal}
								onItemDelete={deleteOrder}
								canEdit={canEdit}
							/>
						</DndProvider>
					</div>
					{isNewOrderModal && (
						<AddNewOrder
							isOpen={isNewOrderModal}
							onClose={() => setIsNewOrderModal(false)}
							issue={modalTitle}
							session={session}
							user={user.id}
							approval={forApproval}
							generalBusiness={generalBusiness}
							forKnowledge={forKnowledge}
							addMatters={addMatters}
							opinions={opinions}
							setApproval={setForApproval}
							setGeneralBusiness={setGeneralBusiness}
							setForKnowledge={setForKnowledge}
							setAddMatters={setAddMatters}
							setOpinions={setOpinions}
							isAuxiliar={dataSesAux.organoColegiado.esAuxiliar}
						/>
					)}
					{isViewOrderModal && (
						<ViewOrder
							isOpen={isViewOrderModal}
							onClose={() => setIsViewOrderModal(false)}
							order={itemSelected}
							user={user}
							canEdit={canEdit}
							nameSesion={dataSesAux.numero_sesion}
						/>
					)}
					{isDetailOrderModal && (
						<DetailOrder
							isOpen={isDetailOrderModal}
							onClose={() => setIsDetailOrderModal(false)}
							issue={modalTitle}
							order={itemSelected}
							session={session}
							user={user}
							setApproval={setForApproval}
							setGeneralBusiness={setGeneralBusiness}
							setForKnowledge={setForKnowledge}
							setAddMatters={setAddMatters}
							setOpinions={setOpinions}
							organoId={organoId}
							canEdit={canEdit}
							isAuxiliar={dataSesAux.organoColegiado.esAuxiliar}
							valOrgan={valOrgan}
							organ={dataSesAux.nameOrgan}
							nameSesion={dataSesAux.numero_sesion}
							updateText={updateText}
							setUpdateText={setUpdateText}
							sectionValidation={dataSesAux.fhora < new Date('2025-03-19')}
						/>
					)}
					{isDeleteOrderModal && (
						<DeleteOrder
							isOpen={canEdit === false ? false : isDeleteOrderModal}
							onClose={() => setIsDeleteOrderModal(false)}
							order={itemSelected}
							onDeleteOrder={(res) => {
								const [
									listForApproval,
									listForKnowledge,
									listGeneralBusiness,
									listAddMatters,
									lstOpinions,
								] = filterResponse(res);

								setForApproval(formatOrders(listForApproval));
								setForKnowledge(formatOrders(listForKnowledge));
								setGeneralBusiness(formatOrders(listGeneralBusiness));
								setAddMatters(formatOrders(listAddMatters));
								setOpinions(formatOrders(lstOpinions));
							}}
						/>
					)}
					{itemSelectedFile !== 0 && (
						<AddFiles
							open={addFilesModal}
							setClose={() => {
								setItemSelectedFile(0);
								setAddFilesModal(false);
							}}
							order={itemSelectedFile}
							user={user}
							canEdit={canEdit}
							nameSesion={dataSesAux.numero_sesion}
							session={session}
						/>
					)}
				</>
			)}
		</div>
	);
};

export default OrderOfTheDay;
